// src/auth/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export const PrivateRoute: React.FC<{ children: React.JSX.Element }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div>로딩 중...</div>; // 토큰 복원 중일 때는 리다이렉트 안 함
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};
